import React from "react";
import Empty from "../../../images/orders/empty.svg";
const EmptyOrder = ({ filter }) => {
  return (
    <div className="flex flex-col items-center gap-4">
      <img src={Empty} alt="" />
      <div className="text-p300 font-semibold text-xl mt-2">
        No {filter !== "all" ? filter : ""} orders!
      </div>
      <div className="font-medium text-center text-sm text-n500 w-60">
        Currently there isn’t any {filter} order available in your profile. You can
        execute new order here.
      </div>
    </div>
  );
};

export default EmptyOrder;
